import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);

    this.$el = this.el;
    this.$date = this.$('date')[0];
    this.$time = this.$('time')[0];

    this.updateTime = this.updateTime.bind(this);
    this.startClock();
  }

  startClock() {
    this.updateTime();
    this.interval = setInterval(this.updateTime, 1000);
  }

  updateTime() {
    const options = {
      timeZone: 'Asia/Nicosia', // Лимассол (Кипр)
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // 12-часовой формат
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(new Date());

    let year, month, day, hour, minute, period;

    parts.forEach(({ type, value }) => {
      if (type === 'year') year = value;
      if (type === 'month') month = value;
      if (type === 'day') day = value;
      if (type === 'hour') hour = value;
      if (type === 'minute') minute = value;
      if (type === 'dayPeriod') period = value;
    });

    if (this.$date) {
      this.$date.textContent = `${year}-${month}-${day}`;
    }
    
    if (this.$time) {
      this.$time.textContent = `${hour}:${minute} ${period}`;
    }
  }

  destroy() {
    super.destroy();
    clearInterval(this.interval);
  }
}